<template>
  <v-card
    flat
    class="pa-3 mt-1 ml-1"
  >
    <v-row>
      <v-card-title>
        Editar departamento
        <VChip
          v-if="connectionsDataLocale.ativo"
          small
          class="ml-2"
          color="success"
          outlined
        >
          Ativo
        </VChip>
        <VChip
          v-else
          small
          class="ml-2"
          color="secondary"
          outlined
        >
          Inativo
        </VChip>
      </v-card-title>
    </v-row>

    <v-form class="multi-col-validation">
      <v-row>
        <v-col
          md="10"
          cols="12"
        >
          <v-text-field
            v-model="connectionsDataLocale.nome"
            label="Nome"
            dense
            outlined
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col
          md="10"
          cols="12"
        >
          <v-textarea
            v-model="connectionsDataLocale.descricao"
            label="Descrição"
            dense
            outlined
          ></v-textarea>
        </v-col>
      </v-row>

      <!-- Salvar -->
      <v-btn
        v-if="!connectionsDataLocale.ativo || !acessoPut"
        color="primary"
        class="me-3 mt-3 mb-3"
        disabled
      >
        Salvar alterações
      </v-btn>
      <v-btn
        v-else
        color="primary"
        class="me-3 mt-3 mb-3"
        @click="update"
      >
        <v-progress-circular
          v-if="carregar"
          indeterminate
          class="me-2"
        >
        </v-progress-circular>

        <span v-else>
          Salvar alterações
        </span>
      </v-btn>

      <v-btn
        outlined
        class="me-3 mt-3 mb-3"
        color="secondary"
        @click.prevent="resetForm"
      >
        Cancelar
      </v-btn>
    </v-form>
  </v-card>
</template>

<script>
import { mdiClose, mdiLinkVariant } from '@mdi/js'
import { ref } from '@vue/composition-api'
import DepartamentoService from '@/services/modules/DepartamentoService'

export default {
  props: {
    connectionsData: {
      type: Object,
      default: () => {},
    },
    acessoPut: {
      type: Boolean,
      default: () => true,
    },
  },

  data: () => ({
    carregar: false,
  }),

  methods: {
    update() {
      this.carregar = !this.carregar

      const departamentoId = this.connectionsDataLocale.id

      DepartamentoService.update(departamentoId, this.connectionsDataLocale)
        .then(() => {
          this.$emit('atualizarDepartamento')
          this.carregar = !this.carregar
        })
        .catch(() => {
          this.carregar = !this.carregar
        })
    },

  },

  setup(props) {
    const connectionsDataLocale = ref(JSON.parse(JSON.stringify(props.connectionsData)))

    const resetForm = () => {
      connectionsDataLocale.value = JSON.parse(JSON.stringify(props.connectionsData))
    }

    return {
      connectionsDataLocale,
      resetForm,
      icons: {
        mdiClose,
        mdiLinkVariant,
      },
    }
  },
}
</script>
